/* Shared numeric-input hardening props for invoicing line-item forms.
 *
 * Feb 2026 — 23 quantity / rate / unit-price / discount / freight-amount
 * inputs across RM Inward, FG Inward, Delivery Challan, Dispatch, Job
 * Work Invoice (via `bill/BillLineItemsTable`), Bill Totals footer,
 * Send-to-Finance, Procurement, and Purchase Order line items were
 * rendering the browser's native spinner control AND letting mouse-wheel
 * / trackpad scroll change their values while focused. Both are silent
 * accidents on invoicing forms (a spurious wheel-tick on a qty field is
 * unrecoverable). This helper is spread onto every such input.
 *
 * Behaviour:
 *   • `className: "no-spinner"` — reuses the existing utility in
 *     `index.css` that suppresses the WebKit / Firefox spinner via
 *     `-webkit-appearance: none` + `-moz-appearance: textfield`. Type,
 *     step, min, max, and numeric parsing are unchanged.
 *   • `onWheel: (e) => e.currentTarget.blur()` — blurs the input before
 *     the browser applies its wheel-increment (a number input only
 *     wheel-increments while focused). Blur does NOT preventDefault, so
 *     the wheel event still bubbles to the page — page-level scroll
 *     past a line-item table continues to work.
 *
 * Use `withNumericInputProps(existingClassName)` when the input already
 * has a className to preserve; the string is merged, not overwritten.
 */
export const NUMERIC_INPUT_PROPS = {
  className: "no-spinner",
  onWheel: (e) => e.currentTarget.blur(),
};

export const withNumericInputProps = (extraClassName = "") => ({
  className: `no-spinner${extraClassName ? " " + extraClassName : ""}`,
  onWheel: (e) => e.currentTarget.blur(),
});
